import { $geocodeHost, $authHost } from ".";
import axios from "axios";

export async function getState() {
    try {
        const { data } = await $authHost.get('/apig/state')
        // console.log(data)
        return data
    } catch (e) {
        console.log(e)
        throw new Error(e)
    }

}

export async function getStateShutdowns() {
    try {
        const { data } = await $authHost.get('/apig/state/shutdowns')
        // console.log(data)
        return data
    } catch (e) {
        console.log(e)
        throw new Error(e)
    }
}

export async function getStateGrid(top, bottom, left, right, zoom) {
    try {
        const { data } = await $authHost.post('/apig/state/grid', { top, bottom, left, right, zoom }, {
            headers: {
                'Accept-Encoding': 'gzip, deflate, br'
            }
        })
        // console.log(data)
        return data
    } catch (e) {
        console.log(e)
        throw new Error(e)
    }
}

export async function searchAddresses(text, options = {}) {
    try {
        const address = encodeURIComponent(`Дагестан ${text}`);
        const { data } = await $geocodeHost.get(`/search.php?q=${address}&polygon_geojson=1&format=jsonv2`, {
            timeout: 10000,
            signal: options.signal
        })
        // console.log(data)
        return data
    } catch (e) {
        if (e.name === 'AbortError' || e.code === 'ERR_CANCELED') {
            throw e; // Re-throw abort errors
        }
        console.log(e)
        return []
        // throw new Error(e);
    }
}

export async function searchAddressesYandex(text, options = {}) {
    try {
        let address = encodeURIComponent(text);
        let url = `https://geocode-maps.yandex.ru/1.x/?format=json&apikey=75fd8440-92c3-4f0e-bea4-e42226d482fd&geocode=${address}`;
        const response = await axios.get(url, {
            timeout: 10000,
            signal: options.signal
        })
        // console.log(response)
        return response.data.response.GeoObjectCollection.featureMember
    } catch (e) {
        if (e.name === 'AbortError' || e.code === 'ERR_CANCELED') {
            throw e; // Re-throw abort errors
        }
        console.log(e)
        throw new Error(e);
    }
}

export async function searchByText(text, options = {}) {
    try {
        const { data } = await $authHost.post('/apig/state/search', { text }, {
            timeout: 10000,
            signal: options.signal
        })
        // console.log(data)
        return data
    } catch (e) {
        if (e.name === 'AbortError' || e.code === 'ERR_CANCELED') {
            throw e; // Re-throw abort errors
        }
        console.log(e)
        return []
        // throw new Error(e);
    }
}

